import useReveal from '@/hooks/useReveal';
import shared from '@/styles/public.module.css';
import styles from './MarketplaceSection.module.css';

// Never name a competitor — the contrast is with the arrangement, not a brand.
const DIRECT = [
  'One rate, take it or leave it',
  'To compare, you re-apply somewhere else',
  'Your attorney fields the same call repeatedly',
  'No way to know if you overpaid',
];

const MARKETPLACE = [
  'One application, seen by every funder on the platform',
  "Offers land side by side, sorted by what you'd repay",
  'Your attorney verifies once, not four times',
  'You can turn all of them down at no cost',
];

const MarketplaceSection = () => {
  const ref = useReveal(shared.rv, shared.revealed);

  return (
    <section
      id="cost"
      className={`${shared.section} ${shared.sectionDark}`}
      ref={ref}
      data-testid="marketplace-section"
    >
      <div className={shared.wrap}>
        <div className={`${shared.secHead} ${shared.rv}`}>
          <span className={shared.eyebrow}>Why a marketplace</span>
          <h2>One company gives you one price. Multiple companies give you a choice.</h2>
          <p>
            Most funding companies quote you their rate and that&rsquo;s the end of
            it. There&rsquo;s nothing to compare it against, so you take it.
          </p>
        </div>

        <div className={styles.cols}>
          <div className={`${styles.col} ${shared.rv}`}>
            <div className={styles.kicker}>Going direct to one funder</div>
            <h3>You get their number</h3>
            <ul className={styles.list}>
              {DIRECT.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div className={`${styles.col} ${styles.win} ${shared.rv}`}>
            <div className={styles.kicker}>MyCaseLoan</div>
            <h3>They compete for you</h3>
            <ul className={styles.list}>
              {MARKETPLACE.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketplaceSection;
